import { render, staticRenderFns } from "./BulkDeleteBrandPopup.vue?vue&type=template&id=324823d5&scoped=true&"
import script from "./BulkDeleteBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeleteBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeleteBrandPopup.vue?vue&type=style&index=0&id=324823d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324823d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324823d5')) {
      api.createRecord('324823d5', component.options)
    } else {
      api.reload('324823d5', component.options)
    }
    module.hot.accept("./BulkDeleteBrandPopup.vue?vue&type=template&id=324823d5&scoped=true&", function () {
      api.rerender('324823d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BulkDeleteBrandPopup.vue"
export default component.exports